/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './device.scss';

/* eslint-disable import/no-unresolved, import/default */

import deviceFieldsetTemplate from './device-fieldset.tpl.html';

/*@ngInject*/
export default function DeviceDirective($compile, $templateCache, $state, $translate, $filter, $window, $timeout, deviceService, multicastGroupService, toast, types, tkDialogs) {
    var linker = function (scope, element) {
        var template = $templateCache.get(deviceFieldsetTemplate);
        element.html(template);

        scope.types = types;
        scope.deviceService = deviceService;

        scope.$watch('device.id.id', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    reset();
                    createDeviceStatSubscription();
                    scope.getDownlinks();
                    resetDownlinkForm();
                }
            }
        });

        scope.onDeviceIdCopied = function() {
            toast.showSuccess($translate.instant('device.idCopiedMessage'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.requestDevStatus = requestDevStatus;

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (scope.isEdit && scope.selectedTab > 2) {
                    scope.selectedTab = 0;
                }
            }
        });

        scope.triggerResize = function() {
            $timeout(() => {
                var w = angular.element($window);
                w.triggerHandler('resize');
                $window.dispatchEvent(new Event("resize")); //eslint-disable-line
            }, 100);
        };


        scope.$on("$destroy", function () {
            reset();
        });

        scope.generateDevAddress = function() {
            deviceService.getUniqueDevAddress().then(
                (newDevAddress) => {
                    scope.device.devAddress = newDevAddress;
                }
            )
        }

        scope.validateAppEUI = function () {
            if (!scope.device.appKey) {
                var tektelicDevRegexp = /647FDA.*/g;
                scope.theForm.appEUI.$setValidity("tektelicDevice", tektelicDevRegexp.test(scope.device.appEUI));
            } else {
                scope.theForm.appEUI.$setValidity("tektelicDevice", true);
            }
        }

        function requestDevStatus() {
            deviceService.requestDeviceStatus(scope.device.id.id).then(
                () => {
                    toast.showSuccess($translate.instant('device.status-requested-message'), 1500, angular.element(element).closest(".toast-parent"), 'bottom left');
                }
            );
        }

        function reset() {
            scope.deviceState = {};
            scope.downlinkQueue = [];

            if (scope.deviceStateSubscriptionHandle) {
                scope.deviceStateSubscriptionHandle();
                scope.deviceStateSubscriptionHandle = null;
            }

            scope.lastActivityTime = null;
            scope.onlineStatus = $translate.instant('device.offline');
            scope.onlineStatusColor = '#ff0000';
            scope.batteryLevel = null;
            scope.margin = null;

        }

        function createDeviceStatSubscription() {
            scope.deviceStateSubscriptionHandle = deviceService.subscribeForDeviceStateData(scope.device.id.id,
                onDeviceStateData);
        }

        function onDeviceStateData(deviceState) {
            scope.$apply(() => {
                scope.deviceState = deviceState;
                if (scope.deviceState.lastActivityTime) {
                    scope.lastActivityTime = $filter('date')(scope.deviceState.lastActivityTime, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    scope.lastActivityTime = null;
                }
                if (scope.deviceState.active) {
                    scope.onlineStatus = $translate.instant('device.online');
                    scope.onlineStatusColor = '#1a901a';
                } else {
                    scope.onlineStatus = $translate.instant('device.offline');
                    scope.onlineStatusColor = '#ff0000';
                }
                scope.batteryLevel = convertBatteryLevel(scope.deviceState.battery);
                scope.margin = convertMargin(scope.deviceState.margin);
            });
        }

        function convertBatteryLevel(rawBatteryLevel) {
            if (angular.isNumber(rawBatteryLevel) && rawBatteryLevel !== 0) {
                if (rawBatteryLevel === 255) {
                    return $translate.instant('device.battery-no-able-to-measure');
                } else {
                    var converted = (rawBatteryLevel / 254) * 100;
                    return converted.toFixed(2) + '%';
                }
            }
        }

        function convertMargin(rawMargin) {
            if (angular.isNumber(rawMargin) && rawMargin !== 0) {
                return rawMargin + ' dB';
            }
        }

        function resetDownlinkForm() {
            scope.downlink = {};
            scope.downlinkForm.$setPristine();
            scope.downlinkForm.$setUntouched();
            scope.showDownlinkForm = false
        }

        scope.getDownlinks = function () {
            deviceService.getDownlinkQueue(scope.device.id.id).then(
                (downlinks) => {
                    scope.downlinkQueue = downlinks;
                }
            );
        };

        scope.openMulticastGroupDetails = function(multicastGroup) {
            $state.go('home.multicastGroups', {entityId: multicastGroup.id });
        }


        scope.deleteDeviceFromMulticasrGroup = function (multicastGroupId) {
            var index = scope.device.multicastGroups.findIndex(a => a.id.id === multicastGroupId);
            index !== -1 && scope.device.multicastGroups.splice(index, 1);
        };

        scope.addDeviceToMulticastGroup = function($event) {
            tkDialogs.selectEntity($event, types.entityType.multicast_group,
                'device.add-to-multicast-group', 'action.ok',
                'device.select-target-add-to-multicast-group-text',
                'multicast-group.no-multicast-group-text',
                'multicast-group.target-multicast-group-required-text').then(
                    (targetMulticastGroupId) => {
                        if (scope.device.multicastGroups.findIndex(mg => mg.id.id === targetMulticastGroupId.id) === -1) {
                            multicastGroupService.getMulticastGroup(targetMulticastGroupId.id).then(
                            (multicastGroup)=> scope.device.multicastGroups.push(multicastGroup)
                            )
                        }
                    }
                );
        }

        scope.clearDownlinks = function ($event) {
            var title = $translate.instant('device.downlinks.clear-queue-warning-title', {deviceName: scope.device.name});
            var content = $translate.instant('device.downlinks.clear-queue-warning-content');
            var label = $translate.instant('device.downlinks.clear-downlink-queue');
            tkDialogs.confirm($event, title, content, label).then(
                () => {
                    deviceService.clearDownlinkQueue(scope.device.id.id).then(
                        () => {
                            scope.getDownlinks();
                        }
                    )
                },
                () => {
                });
        };

        scope.showAddDownlinkForm = function () {
            scope.showDownlinkForm = scope.showDownlinkForm ? ! scope.showDownlinkForm : true;
        };

        scope.initDownlinkForm = function(form) {
            scope.downlinkForm = form
        }

        scope.addDownlinkToQueue = function() {
            deviceService.postDownlinkToQueue(scope.device.id.id, scope.downlink).then(function success() {
                toast.showSuccess($translate.instant('device.downlinks.add-downlink-to-queue-success'));
                resetDownlinkForm();
            });
        }



        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            device: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/device/device.directive.js